module.exports = __webpack_public_path__ + "static/img/mumi-2.35e65bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/mumi-2.jpg
// module id = JvyA
// module chunks = 1